export default __webpack_public_path__ + "static/media/twitter.af31fce4.svg";